import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { useMediaQuery } from 'react-responsive';
import { Link } from 'react-router-dom';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';
import { Media } from '../../../../../theme/Media';
import { NotificationIndicator } from '../../../../Elements/NotificationIndicator';
import { usePuzzleNavigationContext } from '../../context';
import { usePathMatch } from '../../hooks';
import { CornerBadge } from '../CornerBadge';
import { NotificationIndicatorWrapper, TagContainer, Wrapper } from './styled';
const ItemSubLink = ({ title, exact, path, to, onClick, dataTestId, tag, ribbon, showIndicator }) => {
    const match = usePathMatch({ path: path ?? to, exact });
    const isMobile = useMediaQuery({ query: Media.xsMax });
    const { collapseMainNav } = usePuzzleNavigationContext();
    const handleCloseMenu = useCallbackRef(() => {
        if (to && isMobile) {
            collapseMainNav();
        }
    });
    return (_jsxs(Wrapper, { "$active": match, children: [ribbon && _jsx(CornerBadge, { variant: ribbon }), to && (_jsxs(Link, { to: to, onClick: handleCloseMenu, "data-testid": dataTestId, children: [_jsx("span", { children: title }), showIndicator && (_jsx(NotificationIndicatorWrapper, { children: _jsx(NotificationIndicator, { warning: true }) })), tag && _jsx(TagContainer, { children: tag })] })), onClick && (_jsxs("span", { onClick: onClick, "data-testid": dataTestId, children: [_jsx("span", { children: title }), showIndicator && (_jsx(NotificationIndicatorWrapper, { children: _jsx(NotificationIndicator, { warning: true }) })), tag && _jsx(TagContainer, { children: tag })] }))] }));
};
export default memo(ItemSubLink);
